module.exports = __webpack_public_path__ + "d94989df21dc11b45202f341e9945a7d.png";